"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexLink = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("components");
var FlexLink = function () { return (react_1.default.createElement("div", null,
    react_1.default.createElement(components_1.Link, { to: "flex" }, "Flex"),
    react_1.default.createElement("div", { className: "py1 pl4" },
        react_1.default.createElement(components_1.Link, { to: { hash: "align", pathname: "flex" } }, "Align"),
        react_1.default.createElement(components_1.Link, { to: { hash: "justify", pathname: "flex" } }, "Justify")))); };
exports.FlexLink = FlexLink;
